<div class="container-fluid mt-4">
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header mb-3 d-flex align-items-center justify-content-between">
        <h5 class="m-0">Society Type</h5>
        <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#TypesSociety">Add
          Type</button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="TypesSociety" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="TypesSocietyLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="TypesSocietyLabel">Type of Society</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="resetForm()"
                aria-label="Close"></button>
            </div>
            <!-- Modal -->
            <form #formRef="ngForm">
              <div class="modal-body">
                <div class="row">

                  <!-- Society Type -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">Society Type</label>
                    <input type="text" class="form-control" [(ngModel)]="societyTypeList.sName" name="sName" required
                      #sName="ngModel" placeholder="Enter Society Type">
                    <div class="text-danger" *ngIf="sName.invalid && sName.touched">
                      Society Type is required.
                    </div>
                  </div>

                  <!-- Rate of Profit -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">Rate Of Profit</label>
                    <input type="number" class="form-control" [(ngModel)]="societyTypeList.rateOfProfit"
                      name="rateOfProfit" required min="0" max="999999" (keypress)="validateNumber($event)"
                      #rateOfProfit="ngModel" placeholder="Rate Of Profit">
                    <div class="text-danger" *ngIf="rateOfProfit.invalid && rateOfProfit.touched">
                      Rate of Profit is required.
                    </div>
                  </div>

                  <!-- Minimum -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">Minimum</label>
                    <input type="number" class="form-control" [(ngModel)]="societyTypeList.minumum" name="minumum"
                      required min="0" max="999999" (keypress)="validateNumber($event)" #minumum="ngModel"
                      placeholder="Minimum Rate">
                    <div class="text-danger" *ngIf="minumum.invalid && minumum.touched">
                      Minimum rate is required.
                    </div>
                  </div>

                  <!-- Maximum -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">Maximum</label>
                    <input type="number" class="form-control" [(ngModel)]="societyTypeList.maximum" name="maximum"
                      required min="0" max="999999" (keypress)="validateNumber($event)" #maximum="ngModel"
                      placeholder="Maximum Rate">
                    <div class="text-danger" *ngIf="maximum.invalid && maximum.touched">
                      Maximum rate is required.
                    </div>
                  </div>

                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" [disabled]="formRef.invalid"
                  (click)="submitSocietyTypeForm()">Submit</button>
              </div>
            </form>

          </div>
        </div>
      </div>



      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-lg-4 col-md-6">
            <label class="form-label">Enter Keywords</label>
            <input type="text" class="form-control" [(ngModel)]="filter.keyword" (keyup)="search()"
              placeholder="Enter Keywords">
          </div>
          <div class="col-lg-8 col-md-6 text-end">
            <button type="button" class="btn btn-primary" (click)="search()">Search</button>
          </div>
        </div>
      </div>
    </div>
<!-- Pagination controls -->
<div class="pagination-controls"
style="display: flex; justify-content: flex-end; align-items: center; width: 100%;">
<div class="pagination-right" style="display: flex; align-items: center;">
  <label for="rowsPerPage" style="margin-right: 8px;">Display Data:</label>
  <select id="rowsPerPage" [(ngModel)]="page.pageSize" (change)="onRowsPerPageChange()"
    style="padding: 5px; font-size: 14px;">

    <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{size}}</option>
  </select>
</div>
</div>
<br />
    <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="filteredRows"
      [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
      [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
      (page)="setPage($event)" [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
      [loadingIndicator]="loading">
      <!-- S.No. Column -->
      <ngx-datatable-column name="#" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
          <span>{{(page.pageNumber-0)*page.pageSize+rowIndex+1}}</span>
        </ng-template>
      </ngx-datatable-column>

      <!-- Dynamic Columns -->
      <ngx-datatable-column *ngFor="let column of columns" [sortable]="true" [name]="column.name" [prop]="column.prop">
        <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
          {{ value }}
        </ng-template>
      </ngx-datatable-column>

      <!-- Action Column -->
      <ngx-datatable-column name="Action" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <button type="button" class="btn btn-info btn-sm" (click)="loadAuditors(row.iSocietyTypeId)"
            data-bs-toggle="modal" data-bs-target="#TypesSociety">
            <i class="bi bi-person-vcard"></i>
          </button>
          &nbsp;
          <button type="button" class="btn btn-danger btn-sm" (click)="openDeleteModal(row.iSocietyTypeId)"
            data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
            <i class="bi bi-trash3"></i>
          </button>
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>
  </div>




  <div class="modal fade" id="exampleModalCenter" tabindex="-1" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">Delete Society Type</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          Are you sure delete this Society type details?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="confirmDelete()">Delete</button>

        </div>
      </div>
    </div>
  </div>




</div>
</div>